<template>
  <div class="elUploads">
    <span @click="dialogTableVisible = true">
      <slot name="upButton"></slot>
    </span>
    <el-dialog @close="closeDialog" top="25vh" :visible.sync="dialogTableVisible" :destroy-on-close="true"
      :close-on-press-escape="false" :close-on-click-modal="false">
      <el-upload :data="data" :on-success="onSuccess" :on-error="onError" :headers="{ token: Token }"
        :disabled="!(!upLoad.uploadProgress || upLoad.uploadProgress >= 100)" ref="upload" class="upload-demo"
        :on-progress="onProgress" :before-upload="beforeUpload" :show-file-list="false" drag :action="uploadUrl">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <slot name="uploadText">点击上传文件或拖拽</slot>
        </div>
        <div class="el-restrict__text">
          <span v-if="!upLoad.file">Max. File Size: 300 MB</span>
          <span v-else>{{ upLoad.file?.name }}</span>
        </div>
      </el-upload>
      <div class="flexNormal">
        <a v-if="ifStaticTemplate" class="transBTn flexNormal" :href="templateUrl" rel="external nofollow">模版下载</a>
        <div v-else class="transBTn flexNormal" @click.stop="templateDownload">模版下载</div>
        <div class="blueBTn flexNormal" @click.stop="confirmImport">
          <span v-if="!upLoad.uploadProgress || upLoad.uploadProgress >= 100"> <i class="el-icon-right"></i>确认导入</span>
          <el-progress v-else text-color="#fff" :text-inside="true" :stroke-width="31.5"
            :percentage="Number(upLoad.uploadProgress)"></el-progress>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'elUploads',
  data() {
    return {
      dialogTableVisible: false,
      Token: sessionStorage.getItem(`userToken`),
      upLoad: {
        uploadProgress: 0, // 上传进度
        file: null, // 上传内容
        data: null, // 后台上传成功后返回的数据
      },
    };
  },
  props: ['uploadUrl', 'templateUrl', 'data', 'ifStaticTemplate'],
  created() { },
  mounted() { },
  methods: {
    // 确认导入
    confirmImport() {
      if (!this.upLoad.file) {
        this.$message({ message: "请先选择文件", type: "warning" });
        return
      }
      this.$emit("success", this.upLoad.data)
      this.dialogTableVisible = false;
    },
    // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeUpload(file) {
      this.upLoad.file = file;
      this.$set(this.upLoad.file, 'sizeNum', (file.size / 1024).toFixed(1));
      let isLt5M = file.size / 1024 / 1024 < 300;
      let isLt0M = file.size > 1;
      if (!isLt5M || !isLt0M) {
        this.upLoad.file = null;
        this.$message({ message: "请上传正确的文件大小", type: "error" });
        return false;
      }
      this.upLoad.uploadProgress = 0.1;
    },
    // 文件上传时的钩子
    onProgress(event, file, fileList) {
      if (event.type === 'progress') {
        this.upLoad.uploadProgress = Math.floor(event.percent);
        if (this.upLoad.uploadProgress >= 100) {
          this.upLoad.uploadProgress = 95
        }
      }
    },
    // onSuccess
    onSuccess(res, file, fileList) {
      console.log("🚀 ~ res:", res);
      this.upLoad.uploadProgress = 100;
      if (res.code == 200) {
        this.$message({ message: `${file.name}上传成功`, type: "success" });
        this.upLoad.data = res;
      } else {
        this.$message({ message: `${file.name}上传失败，${res.msg}`, type: "error" });
      }
    },
    onError(err, file, fileList) {
      this.$message({ message: `${file.name}上传失败，${err.data.msg}`, type: "error" });
      this.closeDialog();
    },
    // 模版下载
    templateDownload() {
      this.common.downloadFile(this.templateUrl);
    },
    closeDialog() {
      this.$emit("success", this.upLoad.data)
      this.upLoad.uploadProgress = 0;
      this.upLoad.file = null;
      this.upLoad.data = null;
      this.$refs.upload.abort();
    },
  },
};
</script>
<style lang='less' scoped>
/deep/ .el-dialog__wrapper {
  background: rgba(55, 65, 81, 0.50);
}

/deep/.el-dialog {
  width: 85%;
  max-width: 530px;
  background-color: @theme_color;
  border-radius: 10px;
  user-select: none;

  .el-dialog__header {
    padding: 25px;
  }

  .el-dialog__body {
    padding: 0;
    padding-bottom: 20px;
  }

  .el-upload {
    width: 100%;
    padding-top: 0;
    box-sizing: border-box;

    .el-upload-dragger {
      width: 100%;
      height: auto;
      background-color: transparent;
      border: none;
    }

    .el-icon-upload {
      margin: 0px 0 15px 0;
    }

    .el-upload__text {
      color: #9CA3AF;
      font-size: 16px;
      font-weight: 500;
    }

    .el-restrict__text {
      color: #9CA3AF;
      line-height: 30px;
    }
  }
}

.transBTn,
.blueBTn {
  width: 100px;
  height: 32px;
  line-height: normal;
  border-radius: 6px;
  border: 1px solid @status_blue;
  background: rgba(62, 123, 250, 0.50);
  // background: @status_blue;
  font-weight: 500;
  color: #fff;
  font-size: 15px;
  margin-top: 15px;
  cursor: pointer;
  text-decoration: auto;
}

.transBTn {
  background-color: transparent;
  border-color: #fff;
  margin-right: 15px;
}

.el-progress {
  width: 100%;

  /deep/.el-progress-bar__outer {
    border-radius: 0;
    background-color: transparent !important;
  }

  /deep/ .el-progress-bar__inner {
    border-radius: 0;
  }
}
</style>